export const urlStructureFigmaRoot = `/figma`;
export const urlStructureFigmaMain = `${urlStructureFigmaRoot}/main`;
export const urlStructureFigmaSettings = `${urlStructureFigmaRoot}/settings`;
export const urlStructureFigmaExport = `${urlStructureFigmaRoot}/export`;
export const urlStructureFigmaImport = `${urlStructureFigmaRoot}/import`;
export const urlStructureFigmaLogin = `/account/figma/login`;
